import Collapse from '@material-ui/core/Collapse';
import MenuList from '@material-ui/core/MenuList';
import DepartingIcon from '@material-ui/icons/DepartureBoard';
import AdminIcon from '@material-ui/icons/Lock';
import UserIcon from '@material-ui/icons/PermIdentity';
import OperationsIcon from '@material-ui/icons/Settings';
import * as React from 'react';
import { useMiaSelector } from '../../components/hooks';
import { LeftNavHeader } from '../../components/LeftNavHeader';
import { canEditWarehouseUsers, isAdmin, isItOverriddenByType, isUser } from '../../ducks/auth';
import { ShoreMasterDepartment } from '../../ducks/lookups';
import { NavTypes, NavUrls } from '../layoutConstants';
import { MenuLink } from '../MenuLink';

interface IOperationsMenuProps {
  collapsed: boolean;
  menuClassName: string;
  navType: NavTypes;
  onExpandClick: (navType: NavTypes) => any;
  onNavClick: () => any;
  currentLocation: string;
}

let OperationsMenu: React.FunctionComponent<IOperationsMenuProps> = ({
  collapsed,
  menuClassName,
  onExpandClick,
  onNavClick,
  navType,
  currentLocation
}) => {
  const user = useMiaSelector(state => isUser(state, 'operations'));
  const admin = useMiaSelector(state => isAdmin(state, 'operations'));
  const isNavItOverridden = useMiaSelector(state => isItOverriddenByType(state, 'operations'));
  const isWarehouseWriteUser = useMiaSelector(state => canEditWarehouseUsers(state, ShoreMasterDepartment.Operations));
  console.log('hello')
  React.useEffect(() => {
    if (currentLocation.includes('operations')) {
      onExpandClick('operations');
    }
  }, []);

  return (
    <>
      {user && (
        <>
          <LeftNavHeader
            collapsed={collapsed}
            navType={navType}
            onExpandClick={onExpandClick}
            icon={OperationsIcon}
            title="Operations"
            hasWarningColor={isNavItOverridden}
          />
          <Collapse component="li" in={collapsed} timeout="auto" unmountOnExit>
            <MenuList disablePadding>
              <MenuLink
                icon={<DepartingIcon />}
                to={NavUrls.operationsDepartingSoon}
                label="Departing Soon"
                menuClassName={menuClassName}
                onNavClick={onNavClick}
                isActive={currentLocation === NavUrls.operationsDepartingSoon}
              />
              {isWarehouseWriteUser && (
                <MenuLink
                  icon={<UserIcon />}
                  to={NavUrls.operationsUsers}
                  label="Users"
                  menuClassName={menuClassName}
                  onNavClick={onNavClick}
                  isActive={currentLocation === NavUrls.operationsUsers}
                />
              )}
              {admin && (
                <MenuLink
                  icon={<AdminIcon />}
                  to={NavUrls.operationsAdmin}
                  label="Admin"
                  menuClassName={menuClassName}
                  onNavClick={onNavClick}
                  isActive={currentLocation === NavUrls.operationsAdmin}
                />
              )}
            </MenuList>
          </Collapse>
        </>
      )}
    </>
  );
};

OperationsMenu = React.memo<IOperationsMenuProps>(OperationsMenu);
export { OperationsMenu };
